import React, { useEffect, useState, useCallback } from 'react'
import { IconDeviceFloppy, IconTrash } from '@tabler/icons-react'

import { Loader } from '@/components/loaders/Loader'
import { Button } from '@/components/buttons/Button'
import { Card } from '@/components/cards/Card'
import { FormField } from '@/components/forms/FormField'

// This form breaks the mold because we don't want a plaintext
// passphrase floating around in redux
export const PasswordForm = ({
  user,
  updateUser,
  modalClose,
  generatePassphrase,
  reportPassphrase,
}) => {
  const [passphrase, setPassphrase] = useState('')
  const [loading, setLoading] = useState(true)

  const updatePassphrase = useCallback((newPassphrase) => {
    setPassphrase(newPassphrase)
    setLoading(false)
  }, [])

  const deletePassphrase = (e) => {
    user.password = null
    updateUser(user)
    modalClose(e)
  }

  const handleGeneratePassphrase = () => {
    setLoading(true)
    generatePassphrase(updatePassphrase)
  }

  const submitPassphrase = () => {
    user.password = passphrase
    updateUser(user)
    modalClose()
  }

  const submitBadPassphrase = () => {
    reportPassphrase(passphrase)
  }

  useEffect(() => {
    generatePassphrase(updatePassphrase)
  }, [generatePassphrase, updatePassphrase])

  return (
    <div className="field-stack">
      <Card className="flat text-center">
        {loading ? (
          <div>
            <Loader size="large" centered />
          </div>
        ) : (
          <div>
            <h2 data-testid="passphrase">{passphrase}</h2>
          </div>
        )}
        <br />
        <FormField>
          <Button.Group className="gap">
            <Button
              data-testid="save-new-password-button"
              onClick={submitPassphrase}
              brand
              icon={<IconDeviceFloppy />}
            >
              Save New Password
            </Button>
            {user.password && (
              <Button onClick={deletePassphrase} critical icon={<IconTrash />} alignIcon="right">
                Remove BaltoCloud Access
              </Button>
            )}
          </Button.Group>
          <br />
          <br />
          <a
            onClick={handleGeneratePassphrase}
            role="presentation"
            data-testid="generate-passphrase-link"
          >
            Don&apos;t like this phrase? Generate a new one.
          </a>
          <br />
          <br />
          <a onClick={submitBadPassphrase}>This password is horrifying - I want to report it!</a>
        </FormField>
      </Card>
    </div>
  )
}
